import React from 'react'
import styled from 'styled-components'
import { device } from '../globalAssets/breakpoints'
import { useHistory } from 'react-router-dom'
import { desktop, mobile } from '../globalAssets/fontsize'
import { FcApproval } from 'react-icons/fc'
import { FaRegCommentAlt } from 'react-icons/fa'
import moment from 'moment'
import { colors } from 'react-select/src/theme'
import { durationFinder } from '../utils/DurationFormatter'
interface IPostCard {
  userImage?: string
  commentCount?: number
  name?: string
  topic?: string
  description?: string
  created_at?: string
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
}
const PostCard = ({ posts }: any) => {
  const history = useHistory()
  // console.log('reversal', [...posts].reverse())
  const postCardContent = posts.map((post: any) => {
    const duration = durationFinder(post?.created_at)
    return (
      <PostCardContainer
        onClick={() =>
          history.push({
            pathname: `/home/topic/${post?.id}`,
            state: { id: post?.id },
          })
        }
      >
        <RateStar title="approved answers">
          <FcApproval style={{ margin: '0', fontSize: '30px' }} />
          <h3>{post?.totalvalidanswers}</h3>
        </RateStar>
        <Content>
          <div>
            <h1>{post?.title}</h1>
            <p>{post?.description}</p>
          </div>
          <div>
            <img src={post?.user?.photolink} alt={post?.name || 'nm'} />
            <p>
              posted by:{' '}
              <span>
                {post?.user?.firstname} {post?.user?.lastname}
              </span>{' '}
            </p>
            <p style={{ marginLeft: '15px' }}>{duration} ago</p>
            <p
              title="comments"
              style={{
                marginLeft: 'auto',
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <FaRegCommentAlt style={{ marginRight: '4px' }} />
              {post?.answers?.length}
            </p>
          </div>
        </Content>
      </PostCardContainer>
    )
  })
  return <div style={{ width: '100%' }}>{postCardContent}</div>
}

export default PostCard

const PostCardContainer = styled.div`
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  padding: 5px;
  margin-bottom: 20px;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};

  @media ${device.laptop} {
    padding: 1vw 3.6vw 1vw 1.5vw;
    margin-bottom: 1.5vw;
  }
`
export const RateStar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    margin: 0;
    color: ${(props) => props.theme.color};
    font-size: ${mobile.normal};
    @media ${device.laptop} {
      font-size: ${desktop.normal};
    }
  }
`
export const Content = styled.div`
  flex: 1;
  padding-left: 10px;
  & > div:first-child {
    & > h1 {
      margin: 0 0 10px 0;
      color: ${(props) => props.theme.color};
      font-size: ${mobile.normal};
      font-weight: 600;
    }
    & > p {
      color: ${(props) => props.theme.color};
      font-weight: 400;
      margin: 0 0 5px 0;
    }
    padding-bottom: 10px;
    border-bottom: ${(props) => `1px solid ${props.theme.subtleGrey}`};
    margin-bottom: 10px;
  }
  div:last-child {
    border: none;
    display: flex;
    align-items: center;
    img {
      height: 20px;
      width: 20px;
      border-radius: 50%;
    }
    p {
      font-size: 13px;
      margin: 0 0 0 5px;
      font-weight: 500;
      color: ${(props) => props.theme.grey};
      & > span {
        color: ${(props) => props.theme.primaryColor};
      }
    }
  }
  @media ${device.laptop} {
    padding-left: 2vw;
    & > div:first-child {
      & > h1 {
        font-size: ${desktop.normal};
      }
      & > p {
      }
    }
    div:last-child {
      img {
        height: 20px;
        width: 20px;
      }
      p {
        font-size: 0.75vw;
      }
    }
  }
`
